(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCalculator);
  } else {
    // DOM is already ready, run immediately
    initializeCalculator();
  }
  
  function initializeCalculator() {
    const lengthSlider = document.getElementById('length-slider');
    const lengthInput = document.getElementById('extrusion-length');
    const addHoleBtn = document.getElementById('add-hole-btn');
    const holesContainer = document.getElementById('holes-container');
    const holesInput = document.getElementById('holes-prop');
    const tapChecks = document.querySelectorAll('input[name="tappingSides"]');
    const tapInput = document.getElementById('tapping-prop');
    const priceDisplay = document.getElementById('calculated-price');
    const extraLengthCostDisplay = document.getElementById('extra-length-cost');
    const extraLengthMmDisplay = document.getElementById('extra-length-mm');
    const extraLengthContainer = document.getElementById('extra-length-display');
    const tappingCostDisplay = document.getElementById('tapping-cost');
    const tappingCostContainer = document.getElementById('tapping-cost-display');
    const holesCostDisplay = document.getElementById('holes-cost');
    const holesCostContainer = document.getElementById('holes-cost-display');
    const holesCountDisplay = document.getElementById('holes-count');
    const cuttingChargeDisplay = document.getElementById('cutting-charge');
    const cuttingChargeContainer = document.getElementById('cutting-charge-display');
    // const configIdInput = document.getElementById('config-id-prop'); // Not needed - using random IDs
  
  // Calculation constants - will be set by Liquid
  let basePrice, pricePerMm, singleTapPrice, doubleTapPrice, hole8mmTopPrice, hole10mmTopPrice, hole8mmSidePrice, hole10mmSidePrice, cuttingCharge;
  const baseLengthMm = 30;
  
  let holeIdCounter = 0;
  let holes = [];
  const svg = document.getElementById('extrusion-svg');
  const NS = 'http://www.w3.org/2000/svg';
  
  // Reset calculator to initial state
  function resetCalculator() {
    // Reset length to default
    if (lengthInput) lengthInput.value = 1000;
    if (lengthSlider) lengthSlider.value = 1000;
    
    // Uncheck all tapping options
    const tapChecks = document.querySelectorAll('input[name="tappingSides"]');
    tapChecks.forEach(cb => {
      cb.checked = false;
      const wrapper = cb.closest('.checkbox-wrapper');
      if (wrapper) wrapper.classList.remove('checked');
    });
    
    // Clear all holes
    holes = [];
    holeIdCounter = 0;
    const holesContainer = document.getElementById('holes-container');
    if (holesContainer) holesContainer.innerHTML = '';
    
    // Reset hidden inputs
    const holesInput = document.getElementById('holes-prop');
    if (holesInput) holesInput.value = '';
    
    const tapInput = document.getElementById('tapping-prop');
    if (tapInput) tapInput.value = '';
    
    // Remove quantity indicator from price display
    const qtyIndicator = document.querySelector('.qty-indicator');
    if (qtyIndicator) {
      qtyIndicator.remove();
      console.log('🧹 Removed quantity indicator from price display');
    }
    
    // COMMENTED OUT - Force reset quantity to 1
    /*
    const productForm = document.querySelector('.product__info form[action*="/cart/add"]') || 
                        document.querySelector('#product-form') ||
                        document.querySelector('form[action*="/cart/add"]:not(.cart-drawer form)');
    const quantityInput = productForm ? productForm.querySelector('.quantity-selector__input') : null;
    if (quantityInput) {
      quantityInput.value = 1;
      quantityInput.setAttribute('value', '1');
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      console.log('📦 Force reset quantity to 1');
    }
    
    const hiddenQty = productForm ? productForm.querySelector('input[type="hidden"][name="quantity"]') : null;
    if (hiddenQty) {
      hiddenQty.value = 1;
    }
    */
    
    console.log('🔄 Calculator reset complete');
  }
  
  // Initialize constants function - to be called by Liquid template
  window.initAluminumCalculator = function(constants) {
    console.log('🚀 CALCULATOR INIT (two-complex.js)');
    console.log('📋 Values from Shopify:', constants);
    
    // COMMENTED OUT - Don't reset on product change for debugging
    /*
    const currentVariantId = document.querySelector('input[name="id"]')?.value;
    const lastVariantId = sessionStorage.getItem('lastVariantId');
    
    if (currentVariantId && currentVariantId !== lastVariantId) {
      console.log('🔄 Different product detected - forcing reset');
      sessionStorage.setItem('lastVariantId', currentVariantId);
      resetCalculator();
    }
    */
    
    // Shopify product price comes in CENTS already
    basePrice = constants.basePrice || 0;
    
    // Metafield values come in DOLLARS - convert to cents for calculation consistency
    pricePerMm = (constants.pricePerMm || 0) * 100;
    singleTapPrice = (constants.singleTapPrice || 0) * 100;
    doubleTapPrice = (constants.doubleTapPrice || 0) * 100;
    hole8mmTopPrice = (constants.hole8mmTopPrice || 0) * 100;
    hole10mmTopPrice = (constants.hole10mmTopPrice || 0) * 100;
    hole8mmSidePrice = (constants.hole8mmSidePrice || 0) * 100;
    hole10mmSidePrice = (constants.hole10mmSidePrice || 0) * 100;
    cuttingCharge = (constants.cuttingCharge || 0) * 100;
    
    console.log('💰 === PRICING LOADED ===');
    console.log('  Base Price (Shopify):', basePrice, 'cents = $' + (basePrice/100).toFixed(2));
    console.log('  Price per mm:', pricePerMm);
    console.log('  Single Tap:', singleTapPrice);
    console.log('  Double Tap:', doubleTapPrice);
    console.log('  8mm Top Hole:', hole8mmTopPrice);
    console.log('  10mm Top Hole:', hole10mmTopPrice);
    console.log('  8mm Side Hole:', hole8mmSidePrice);
    console.log('  10mm Side Hole:', hole10mmSidePrice);
    console.log('  Cutting Charge:', cuttingCharge);
    console.log('  Base Length: 30mm');
    
    // Store config globally for access in hole creation
    window.ALUMINUM_CONFIG = constants;
    window.ALUMINUM_CONFIG.sideSlots = 2; // This template has 2 side slots
    
    // Reset calculator on initialization to clear any browser-cached values
    // COMMENTED OUT - Don't reset
    // resetCalculator();
    console.log('⚠️ Initial reset disabled (two-complex.js)');
    
    // Hide 10mm bullet point if both top and side prices are 0
    if (hole10mmTopPrice === 0 && hole10mmSidePrice === 0) {
      const bulletPoints = document.querySelectorAll('.input-label p');
      bulletPoints.forEach(p => {
        if (p.textContent.includes('Ø10 mm')) {
          p.style.display = 'none';
        }
      });
    }
    
    // Initialize on page load
    setTimeout(() => {
      // COMMENTED OUT - Don't reset form values
      // resetCalculator();
      
      updateZoom();
      updatePrice();
      draw();
      
      // Setup quantity change listeners
      setupQuantityListeners();
      
      function setupQuantityListeners() {
        // First try to find quantity-selector in the product form
        const productForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(form => 
          !form.closest('.cart-drawer, .drawer, [class*="mini-cart"], [id*="cart"]')
        );
        
        let quantitySelector = productForm ? productForm.querySelector('quantity-selector') : null;
        
        // If not found in product form, look globally
        if (!quantitySelector) {
          quantitySelector = document.querySelector('quantity-selector');
        }
        
        if (quantitySelector) {
          const quantityButtons = quantitySelector.querySelectorAll('.quantity-selector__button');
          
          quantityButtons.forEach((button) => {
            ['click'].forEach(eventType => {
              button.addEventListener(eventType, (e) => {
                setTimeout(() => {
                  updatePrice();
                  draw();
                }, 50);
              });
            });
          });
        }
      }
      
      // Legacy code below - keeping for compatibility
      const productForm = document.querySelector('.product__info form[action*="/cart/add"]') || 
                          document.querySelector('#product-form') ||
                          document.querySelector('form[action*="/cart/add"]:not(.cart-drawer form)');
      const quantityInput = productForm ? productForm.querySelector('.quantity-selector__input') : null;
      
      if (quantityInput) {
        quantityInput.addEventListener('change', () => {
          updatePrice();
          
          // Ensure quantity is synced with form
          if (productForm) {
            // Check for existing hidden quantity input
            let hiddenQty = productForm.querySelector('input[type="hidden"][name="quantity"]');
            if (!hiddenQty) {
              hiddenQty = document.createElement('input');
              hiddenQty.type = 'hidden';
              hiddenQty.name = 'quantity';
              productForm.appendChild(hiddenQty);
            }
            hiddenQty.value = quantityInput.value;
            console.log('Synced quantity to form:', quantityInput.value);
          }
        });
        
        // Also listen for the custom quantity selector buttons IN PRODUCT FORM ONLY
        const quantitySelector = productForm ? productForm.querySelector('quantity-selector') : null;
        if (quantitySelector) {
          // Listen for clicks on the entire selector to catch button clicks
          quantitySelector.addEventListener('click', () => {
            // Small delay to let the input value update
            setTimeout(() => {
              updatePrice();
              
              // Sync quantity with form
              const productForm = document.querySelector('form[action*="/cart/add"]');
              if (productForm) {
                let hiddenQty = productForm.querySelector('input[type="hidden"][name="quantity"]');
                if (!hiddenQty) {
                  hiddenQty = document.createElement('input');
                  hiddenQty.type = 'hidden';
                  hiddenQty.name = 'quantity';
                  productForm.appendChild(hiddenQty);
                }
                hiddenQty.value = quantityInput.value;
                console.log('Synced quantity to form:', quantityInput.value);
              }
            }, 10);
          });
        }
      }
      
      // Add length adjustment buttons with hold-to-repeat and ruler marks
      const lengthDecrease = document.getElementById('length-decrease');
      const lengthIncrease = document.getElementById('length-increase');
      
      // Variables for hold-to-repeat functionality
      let adjustInterval = null;
      let adjustTimeout = null;
      
      // Function to handle length adjustment
      function adjustLength(delta) {
        const currentValue = parseInt(lengthInput.value) || 1000;
        const newValue = Math.max(30, Math.min(3000, currentValue + delta));
        
        // Check if we're reducing length and have holes that would be affected
        if (delta < 0 && newValue < currentValue) {
          if (!handleLengthReduction(newValue)) {
            // Stop the repeat if user cancels
            clearInterval(adjustInterval);
            clearTimeout(adjustTimeout);
            return false;
          }
        }
        
        if (newValue !== currentValue) {
          lengthInput.value = newValue;
          lengthSlider.value = newValue;
          updateSliderBubble();
          updateHoleInputsMax();
          updatePrice();
          draw();
          updateConfigId();
          updateAdjustmentButtons();
          
          // Show notification if reached 3000
          if (newValue >= 3000) {
            const notification = document.getElementById('length-notification');
            if (notification) {
              notification.classList.remove('hiding');
              notification.style.display = 'block';
            }
          }
        }
        
        // Stop if we've reached the limit
        if (newValue <= 30 || newValue >= 3000) {
          clearInterval(adjustInterval);
          clearTimeout(adjustTimeout);
        }
        
        return true;
      }
      
      // Setup hold-to-repeat for decrease button
      if (lengthDecrease) {
        // Single click
        lengthDecrease.addEventListener('click', () => {
          adjustLength(-1);
        });
        
        // Hold to repeat
        lengthDecrease.addEventListener('mousedown', (e) => {
          e.preventDefault();
          // Start repeating after 500ms hold
          adjustTimeout = setTimeout(() => {
            adjustInterval = setInterval(() => {
              if (!adjustLength(-1)) {
                clearInterval(adjustInterval);
              }
            }, 50); // Repeat every 50ms for smooth adjustment
          }, 500);
        });
        
        // Stop on mouse up or leave
        lengthDecrease.addEventListener('mouseup', () => {
          clearInterval(adjustInterval);
          clearTimeout(adjustTimeout);
        });
        
        lengthDecrease.addEventListener('mouseleave', () => {
          clearInterval(adjustInterval);
          clearTimeout(adjustTimeout);
        });
      }
      
      // Setup hold-to-repeat for increase button
      if (lengthIncrease) {
        // Single click
        lengthIncrease.addEventListener('click', () => {
          adjustLength(1);
        });
        
        // Hold to repeat
        lengthIncrease.addEventListener('mousedown', (e) => {
          e.preventDefault();
          // Start repeating after 500ms hold
          adjustTimeout = setTimeout(() => {
            adjustInterval = setInterval(() => {
              if (!adjustLength(1)) {
                clearInterval(adjustInterval);
              }
            }, 50); // Repeat every 50ms for smooth adjustment
          }, 500);
        });
        
        // Stop on mouse up or leave
        lengthIncrease.addEventListener('mouseup', () => {
          clearInterval(adjustInterval);
          clearTimeout(adjustTimeout);
        });
        
        lengthIncrease.addEventListener('mouseleave', () => {
          clearInterval(adjustInterval);
          clearTimeout(adjustTimeout);
        });
      }
      
      // Add click handlers for ruler marks
      document.querySelectorAll('.ruler-mark.clickable').forEach(mark => {
        mark.addEventListener('click', (e) => {
          const value = parseInt(mark.dataset.value);
          
          // Check if we're reducing length and have holes that would be affected
          const currentLength = parseFloat(lengthInput.value) || 1000;
          if (value < currentLength) {
            if (!handleLengthReduction(value)) {
              // User cancelled, don't change
              return;
            }
          }
          
          // Update values
          lengthInput.value = value;
          lengthSlider.value = value;
          updateSliderBubble();
          updateAdjustmentButtons();
          updateHoleInputsMax();
          updatePrice();
          draw();
          updateConfigId();
          
          // Show notification if 3000 is selected
          if (value >= 3000) {
            const notification = document.getElementById('length-notification');
            if (notification) {
              notification.classList.remove('hiding');
              notification.style.display = 'block';
            }
          }
        });
      });
      
      // Update on manual input changes
      lengthInput.addEventListener('input', () => {
        updatePresetButtons(parseInt(lengthInput.value));
      });
      
      lengthSlider.addEventListener('input', () => {
        updatePresetButtons(parseInt(lengthSlider.value));
      });
    }, 100);
  };
  
  // 3D drawing system
  const dimensionalValues = {
    baseScale: 20,
    visualLength: 400,
    isoAngle: 60,
    backWidth: 400,
    backHeight: 60,
    topDepth: 60,
    topWidth: 400,
    topOpacity: 1,
    topColor: '#f5f5f5',
    rightHeight: 60,
    rightDepth: 60,
    rightOpacity: 1,
    leftHeight: 60,
    leftDepth: 60,
    leftOpacity: 0,
    frontSlotWidth: 0.3,
    topSlotWidth: 0.3,
    mainX: 750,
    mainY: 250,
    isoX: -150,
    dimY: 60,
    arrowSize: 8,
    holeScale: 0.67,
    vHoleRatio: 0.6
  };
  
  const leftTapping = { radius: 14, x: -20, y: -3 };
  const rightTapping = { radius: 14, x: 20, y: -2 };
  
  const profileDimensions = {
    '30x30': [30, 30]
  };
  
  let currentProfile = '30x30';
  let zoomLevel = 2;
  let panX = 0;
  let panY = 0;
  
  function updateZoom() {
    if (svg) {
      svg.style.transform = `scale(${zoomLevel})`;
    }
  }
  
  function clampLen(length) {
    return Math.max(30, Math.min(3000, length));
  }
  
  function clampPos(v, L) { 
    return Math.min(Math.max(v, 0), L); 
  }
  
  const E = (tag, attrs) => {
    const elem = document.createElementNS(NS, tag);
    Object.entries(attrs).forEach(([k, v]) => elem.setAttribute(k, v));
    return elem;
  };
  
  function updateHolesData() {
    if (holes.length === 0) {
      holesInput.value = '';
      updateConfigId();
      checkHoleSpacing();
      return;
    }
    
    // Check configuration for number of side slots
    const sideSlots = window.ALUMINUM_CONFIG && window.ALUMINUM_CONFIG.sideSlots || 2;
    
    let holesText = '';
    holes.forEach(hole => {
      if (hole.position) {
        let railText;
        if (hole.rail === '1') {
          railText = 'Top Slot';
        } else if (hole.rail === '2') {
          railText = sideSlots === 2 ? 'Side Slot 1' : 'Side Slot';
        } else if (hole.rail === '3') {
          railText = 'Side Slot 2';
        }
        const orientText = hole.orientation === 'Horizontal' ? 'From Left to Right' : 'From Right to Left';
        holesText += `Diameter: ${hole.diameter}mm, ${railText}, ${hole.position}mm, ${orientText}\n`;
      }
    });
    
    holesInput.value = holesText.trim();
    updateConfigId();
    checkHoleSpacing();
  }
  
  function checkHoleSpacing() {
    const warningDiv = document.getElementById('holes-warning');
    if (!warningDiv) return;
    
    let tooClose = false;
    const L = clampLen(+lengthInput.value); // Get current beam length
    
    // Get holes with positions on the same rail
    const holesWithPos = holes.filter(h => h.position && h.position !== '');
    
    // Check each hole for edge distance
    for (let i = 0; i < holesWithPos.length; i++) {
      const hole = holesWithPos[i];
      const pos = parseFloat(hole.position);
      
      // Check distance from edges (10mm minimum from left or right edge)
      if (pos < 10 || pos > (L - 10)) {
        tooClose = true;
        break;
      }
    }
    
    // Check each pair of holes for spacing between them
    if (!tooClose) {
      for (let i = 0; i < holesWithPos.length; i++) {
        for (let j = i + 1; j < holesWithPos.length; j++) {
          const hole1 = holesWithPos[i];
          const hole2 = holesWithPos[j];
          
          // Only check holes on the same rail
          if (hole1.rail === hole2.rail) {
            const pos1 = parseFloat(hole1.position);
            const pos2 = parseFloat(hole2.position);
            
            // Calculate actual physical positions from the left edge
            // "From Left to Right" (Horizontal): position is from left
            // "From Right to Left" (Vertical): position is from right, so actual position from left is (L - position)
            let physicalPos1, physicalPos2;
            
            if (hole1.orientation === 'Vertical') {
              physicalPos1 = L - pos1; // Convert right-based position to left-based
            } else {
              physicalPos1 = pos1; // Already left-based
            }
            
            if (hole2.orientation === 'Vertical') {
              physicalPos2 = L - pos2; // Convert right-based position to left-based
            } else {
              physicalPos2 = pos2; // Already left-based
            }
            
            const distance = Math.abs(physicalPos1 - physicalPos2);
            
            // Debug logging
            console.log('Hole spacing check:', {
              hole1: { pos: pos1, orientation: hole1.orientation, physicalPos: physicalPos1 },
              hole2: { pos: pos2, orientation: hole2.orientation, physicalPos: physicalPos2 },
              distance: distance,
              tooClose: distance < 15,
              beamLength: L
            });
            
            if (distance < 15) {
              tooClose = true;
              break;
            }
          }
        }
        if (tooClose) break;
      }
    }
    
    // Show or hide warning
    warningDiv.style.display = tooClose ? 'block' : 'none';
  }
  
  function syncTaps() {
    const leftChecked = document.querySelector('input[name="tappingSides"][value="Left"]').checked;
    const rightChecked = document.querySelector('input[name="tappingSides"][value="Right"]').checked;
    
    console.log('=== TAPPING DEBUG ===');
    console.log('Left checked:', leftChecked);
    console.log('Right checked:', rightChecked);
    
    if (leftChecked && rightChecked) {
      tapInput.value = 'tap both ends M8';
      console.log('Set to: tap both ends M8 (should cost $4.10)');
      console.log('Hidden input now contains:', tapInput.value);
    } else if (leftChecked) {
      tapInput.value = 'tap left end M8';
      console.log('Set to: tap left end M8 (should cost $3.10)');
      console.log('Hidden input now contains:', tapInput.value);
    } else if (rightChecked) {
      tapInput.value = 'tap right end M8';
      console.log('Set to: tap right end M8 (should cost $3.10)');
      console.log('Hidden input now contains:', tapInput.value);
    } else {
      tapInput.value = '';
      console.log('Set to: no tapping');
      console.log('Hidden input now contains:', tapInput.value);
    }
    
    updatePrice();
    draw();
    updateConfigId();
  }
  
  function updateConfigId() {
    // Disabled - using random IDs in cart interceptor instead
    return;
  }
  
  function updatePrice() {
    // Check if pricing constants are initialized
    if (typeof basePrice === 'undefined' || typeof pricePerMm === 'undefined' || 
        typeof singleTapPrice === 'undefined' || typeof doubleTapPrice === 'undefined' ||
        typeof hole8mmTopPrice === 'undefined' || typeof hole10mmTopPrice === 'undefined' ||
        typeof hole8mmSidePrice === 'undefined' || typeof hole10mmSidePrice === 'undefined') {
      return;
    }
    
    // Get quantity for calculation - direct approach
    const emergencyQuantityInput = document.querySelector('.quantity-selector__input:not([name="updates[]"])');
    const quantity = emergencyQuantityInput ? parseInt(emergencyQuantityInput.value) || 1 : 1;
    
    const lengthMm = parseFloat(lengthInput.value) || 0;
    const tappingOption = tapInput.value;
    
    const extraLength = Math.max(0, lengthMm - baseLengthMm);
    // Price per mm is now already in cents
    const extraLengthCost = extraLength * pricePerMm;
    
    console.log('📏 Length Calculation:');
    console.log('  Extra Length (mm):', extraLength, '=', lengthMm, '-', baseLengthMm);
    console.log('  Price per mm (cents):', pricePerMm);
    console.log('  Extra Length Cost (cents):', extraLengthCost, '=', extraLength, '×', pricePerMm);
    
    let tappingCost = 0;
    if (tappingOption === 'tap left end M8' || tappingOption === 'tap right end M8' || tappingOption === 'tap one end M8') {
      // Single tap price is in dollars, convert to cents
      tappingCost = singleTapPrice;
      console.log('🔧 Tapping: Single End M8, Cost:', tappingCost, 'cents');
    } else if (tappingOption === 'tap both ends M8') {
      // Double tap price is in dollars, convert to cents
      tappingCost = doubleTapPrice;
      console.log('🔧 Tapping: Both Ends M8, Cost:', tappingCost, 'cents');
    } else {
      console.log('🔧 Tapping: None');
    }
    
    let holesCost = 0;
    let holesCount = 0;
    console.log('🕳️ Holes Calculation:');
    console.log('  Total holes array:', holes.length);
    holes.forEach(hole => {
      // Only count holes that have a valid position entered
      if (hole.position && hole.position !== '' && !isNaN(parseFloat(hole.position))) {
        holesCount++;
        const isTopSlot = hole.rail === '1'; // Rail 1 is Top Slot
        
        if (hole.diameter === '8') {
          // Hole price is already in cents (converted at initialization)
          const cost = isTopSlot ? hole8mmTopPrice : hole8mmSidePrice;
          holesCost += cost;
          console.log(`    → 8mm ${isTopSlot ? 'top' : 'side'} hole added, cost: ${cost} cents`);
        } else if (hole.diameter === '10') {
          // Hole price is already in cents (converted at initialization)
          const cost = isTopSlot ? hole10mmTopPrice : hole10mmSidePrice;
          holesCost += cost;
          console.log(`    → 10mm ${isTopSlot ? 'top' : 'side'} hole added, cost: ${cost} cents`);
        }
      }
    });
    console.log('  Valid holes count:', holesCount);
    console.log('  Total holes cost:', holesCost, 'cents');
    
    // Add cutting charge (convert from dollars to cents)
    const cuttingCost = cuttingCharge;
    console.log('✂️ Cutting Charge:', cuttingCost, 'cents');
    
    // Calculate unit price - base price is in cents, all others converted to cents
    console.log('\n💵 === FINAL PRICE CALCULATION ===');
    console.log('  Base Price (Shopify):', Number(basePrice), 'cents');
    console.log('  + Extra Length Cost:', Number(extraLengthCost), 'cents');
    console.log('  + Tapping Cost:', Number(tappingCost), 'cents');
    console.log('  + Holes Cost:', Number(holesCost), 'cents');
    console.log('  + Cutting Charge:', Number(cuttingCost), 'cents');
    console.log('  ─────────────────────────');
    
    const unitPrice = Number(basePrice) + Number(extraLengthCost) + Number(tappingCost) + Number(holesCost) + Number(cuttingCost);
    console.log('  = Total Price:', unitPrice, 'cents ($' + (unitPrice/100).toFixed(2) + ')');
    
    // === VISUAL CALCULATION ONLY - DOES NOT AFFECT ACTUAL CART PRICING ===
    // Calculate total price including quantity for product page display guidance
    const totalPrice = Math.round(unitPrice * quantity * 100) / 100;  // Multiply by quantity for VISUAL display
    
    // Update main price display - CONVERT CENTS TO DOLLARS FOR DISPLAY
    const displayPrice = (totalPrice / 100).toFixed(2);  // Convert cents to dollars
    priceDisplay.textContent = displayPrice;
    
    // Update individual cost displays - MULTIPLY BY QUANTITY AND CONVERT CENTS TO DOLLARS
    extraLengthCostDisplay.textContent = (extraLengthCost * quantity / 100).toFixed(2);
    extraLengthMmDisplay.textContent = extraLength;
    tappingCostDisplay.textContent = (tappingCost * quantity / 100).toFixed(2);
    holesCostDisplay.textContent = (holesCost * quantity / 100).toFixed(2);
    holesCountDisplay.textContent = holesCount * quantity;
    cuttingChargeDisplay.textContent = (cuttingCost * quantity / 100).toFixed(2);
    
    // Add quantity indicator if more than 1 to show unit price breakdown
    if (quantity > 1) {
      console.log('🔍 Searching for quantity indicator placement...');
      
      // Strategy 1: Try to find the exact price display element and add it inline
      let targetElement = document.querySelector('#calculated-price');
      let placement = 'after-price';
      
      if (!targetElement) {
        // Strategy 2: Try to find price-related headers
        targetElement = document.querySelector('.header__grid h3') || 
                       document.querySelector('.product__title') ||
                       document.querySelector('.product-title') ||
                       document.querySelector('h1');
        placement = 'in-header';
      }
      
      if (!targetElement) {
        // Strategy 3: Find any element with "price" in the class/id
        targetElement = document.querySelector('[class*="price"], [id*="price"]');
        placement = 'near-price';
      }
      
      console.log('📍 Target element found:', targetElement?.tagName, targetElement?.className, 'placement:', placement);
      
      if (targetElement) {
        // Remove any existing indicator first
        const existingIndicator = document.querySelector('.qty-indicator');
        if (existingIndicator) existingIndicator.remove();
        
        // Create new indicator
        const qtyIndicator = document.createElement('span');
        qtyIndicator.className = 'qty-indicator';
        qtyIndicator.style.cssText = 'font-size: 14px; color: #666; margin-left: 8px; font-weight: normal;';
        qtyIndicator.textContent = `(${quantity} × $${(unitPrice/100).toFixed(2)})`;
        
        if (placement === 'after-price' && targetElement.tagName !== 'INPUT') {
          // Add directly after the price display
          targetElement.appendChild(qtyIndicator);
        } else if (targetElement.parentElement) {
          // Add after the target element
          targetElement.parentElement.insertBefore(qtyIndicator, targetElement.nextSibling);
        } else {
          // Fallback: append to target
          targetElement.appendChild(qtyIndicator);
        }
        
        console.log('✅ Added quantity indicator:', qtyIndicator.textContent, 'to', targetElement.tagName);
        
        // Debug: Log the actual HTML structure around the indicator
        console.log('🔍 HTML structure:', qtyIndicator.parentElement?.outerHTML?.substring(0, 200));
      } else {
        console.log('❌ Could not find any suitable element for quantity indicator');
        
        // Emergency fallback: Add to body with absolute positioning
        const existingIndicator = document.querySelector('.qty-indicator');
        if (existingIndicator) existingIndicator.remove();
        
        const qtyIndicator = document.createElement('div');
        qtyIndicator.className = 'qty-indicator';
        qtyIndicator.style.cssText = 'position: fixed; top: 100px; right: 20px; background: rgba(0,0,0,0.8); color: white; padding: 5px 10px; border-radius: 4px; z-index: 1000; font-size: 14px;';
        qtyIndicator.textContent = `${quantity} × $${(unitPrice/100).toFixed(2)}`;
        document.body.appendChild(qtyIndicator);
        
        console.log('🚨 Emergency fallback: Added floating quantity indicator');
      }
    } else {
      // Remove indicator if quantity is 1
      const indicator = document.querySelector('.qty-indicator');
      if (indicator) {
        indicator.remove();
        console.log('🗑️ Removed quantity indicator');
      }
    }
    
    // DISABLED: Quantity indicator temporarily disabled to fix calculation issues
    // The qty indicator was causing problems when qty changes in cart drawer/page
    // Will re-enable once the calculation workflow is fixed
    /*
    // Add quantity indicator if more than 1
    if (quantity > 1) {
      const priceHeader = document.querySelector('.header__grid h3');
      if (priceHeader) {
        // Check if indicator already exists
        let qtyIndicator = priceHeader.querySelector('.qty-indicator');
        
        if (qtyIndicator) {
          // Update existing indicator
          qtyIndicator.textContent = `(${quantity} × $${unitPrice.toFixed(2)})`;
        } else {
          // Create new indicator
          qtyIndicator = document.createElement('span');
          qtyIndicator.className = 'qty-indicator';
          qtyIndicator.style.cssText = 'font-size: 14px; color: #666; margin-left: 10px;';
          qtyIndicator.textContent = `(${quantity} × $${unitPrice.toFixed(2)})`;
          priceHeader.appendChild(qtyIndicator);
        }
      }
    } else {
      // Remove indicator if quantity is 1
      const indicator = document.querySelector('.qty-indicator');
      if (indicator) indicator.remove();
    }
    */
    
    // Quantity indicator handled above - no cleanup needed
    
    extraLengthContainer.style.display = extraLength > 0 ? 'block' : 'none';
    tappingCostContainer.style.display = tappingCost > 0 ? 'block' : 'none';
    holesCostContainer.style.display = holesCount > 0 ? 'block' : 'none';
    cuttingChargeContainer.style.display = cuttingCost > 0 ? 'block' : 'none';

    // Update mirroring warning visibility
    updateMirroringWarning();
  }

  function updateMirroringWarning() {
    const mirroringWarning = document.getElementById('mirroring-warning');
    if (!mirroringWarning) return;

    // Only show for asymmetric profiles (40-80-90 and 30-60-90)
    const productHandle = mirroringWarning.dataset.productHandle || '';
    const isAsymmetricProfile = productHandle.includes('40-80-90') || productHandle.includes('30-60-90');
    if (!isAsymmetricProfile) return;

    // Show warning as soon as any hole is added (user may increase qty in cart later)
    mirroringWarning.style.display = holes.length > 0 ? 'block' : 'none';
  }

  function draw() {
    if (!svg) return;
    
    const L = clampLen(+lengthInput.value);
    const [profileW, profileH] = profileDimensions[currentProfile];
    
    svg.innerHTML = '';
    
    const mainX = dimensionalValues.mainX;
    const mainY = dimensionalValues.mainY;
    const g = E('g', { transform: `translate(${mainX}, ${mainY})` });
    
    drawIsometricView(g, L, profileW, profileH);
    
    svg.appendChild(g);
  }
  
  function drawIsometricView(parentG, L, profileW, profileH) {
    const backWidth = 300;
    const backHeight = 120;
    
    const isoX = -150;
    const g = E('g', { transform: `translate(${isoX}, 100)` });
    
    // Main back face - rectangular shape
    const backFace = E('rect', {
      x: -150,
      y: -60,
      width: 300,
      height: 120,
      class: 'profile-shape',
      fill: '#d8d8d8'
    });
    
    // Top face - adjusted for new dimensions and 20% thinner
    const topFace = E('path', {
      d: `M -150 -60
          L -126 -101.569219455852654
          L 174 -101.569219455852654
          L 150 -60
          Z`,
      fill: '#f5f5f5',
      opacity: 1,
      stroke: '#333',
      'stroke-width': '1'
    });
    
    // Bottom face removed as requested
    
    // Right face - adjusted for rectangular shape and thinner top
    const rightFace = E('path', {
      d: `M 150 -60
          L 174 -101.569219455852654
          L 174 18.430780544147346
          L 150 60
          Z`,
      fill: '#dcdcdc',
      opacity: 1,
      stroke: '#333',
      'stroke-width': '1'
    });
    
    // Left face - adjusted for rectangular shape and thinner top
    const leftFace = E('path', {
      d: `M -150 -60
          L -126 -101.569219455852654
          L -126 18.430780544147346
          L -150 60
          Z`,
      fill: '#dcdcdc',
      opacity: 0,
      stroke: '#333',
      'stroke-width': '1'
    });
    
    g.appendChild(backFace);
    g.appendChild(topFace);
    // Bottom face removed
    g.appendChild(rightFace);
    g.appendChild(leftFace);
    
    drawTSlotDetails(g, backWidth, backHeight, 60, backWidth, 0.5, 0.866025403784439);
    
    // Check which holes are too close
    const tooCloseHoles = new Set();
    const holesWithPos = holes.filter(h => h.position && h.position !== '');
    
    // Check edge distances
    for (let i = 0; i < holesWithPos.length; i++) {
      const pos = parseFloat(holesWithPos[i].position);
      if (pos < 10 || pos > (L - 10)) {
        tooCloseHoles.add(holesWithPos[i].id);
      }
    }
    
    // Check spacing between holes
    for (let i = 0; i < holesWithPos.length; i++) {
      for (let j = i + 1; j < holesWithPos.length; j++) {
        if (holesWithPos[i].rail === holesWithPos[j].rail) {
          const pos1 = parseFloat(holesWithPos[i].position);
          const pos2 = parseFloat(holesWithPos[j].position);
          
          // Calculate actual physical positions from the left edge
          let physicalPos1, physicalPos2;
          
          if (holesWithPos[i].orientation === 'Vertical') {
            physicalPos1 = L - pos1; // Right to Left: position from right edge
          } else {
            physicalPos1 = pos1; // Left to Right: position from left edge
          }
          
          if (holesWithPos[j].orientation === 'Vertical') {
            physicalPos2 = L - pos2; // Right to Left: position from right edge
          } else {
            physicalPos2 = pos2; // Left to Right: position from left edge
          }
          
          const distance = Math.abs(physicalPos1 - physicalPos2);
          if (distance < 15) {
            tooCloseHoles.add(holesWithPos[i].id);
            tooCloseHoles.add(holesWithPos[j].id);
          }
        }
      }
    }
    
    // Sort holes by position for label staggering
    const sortedHolesByRail = {
      '1': holes.filter(h => h.rail === '1' && h.position).sort((a, b) => parseFloat(a.position) - parseFloat(b.position)),
      '2': holes.filter(h => h.rail === '2' && h.position).sort((a, b) => parseFloat(a.position) - parseFloat(b.position)),
      '3': holes.filter(h => h.rail === '3' && h.position).sort((a, b) => parseFloat(a.position) - parseFloat(b.position))
    };
    
    // Calculate label offsets to prevent overlap
    const labelOffsets = new Map();
    const pixelsPerMm = backWidth / L;
    const minLabelSpacing = Math.max(30, 200 * pixelsPerMm * 0.3); // Dynamic spacing based on scale
    
    ['1', '2', '3'].forEach(rail => {
      const railHoles = sortedHolesByRail[rail];
      for (let i = 0; i < railHoles.length; i++) {
        let offset = 0;
        if (i > 0) {
          const prevHole = railHoles[i - 1];
          const prevPos = parseFloat(prevHole.position);
          const currPos = parseFloat(railHoles[i].position);
          const mmDistance = currPos - prevPos;
          
          // Check if labels would overlap (within 200mm as user mentioned)
          if (mmDistance < 200) {
            // Alternate between 3 different heights based on proximity
            const prevOffset = labelOffsets.get(prevHole.id) || 0;
            if (mmDistance < 50) {
              offset = (prevOffset + 2) % 3; // Far stagger for very close holes
            } else if (mmDistance < 100) {
              offset = (prevOffset + 1) % 3; // Medium stagger
            } else {
              offset = prevOffset > 0 ? 0 : 1; // Light stagger
            }
          }
        }
        labelOffsets.set(railHoles[i].id, offset);
      }
    });
    
    holes.forEach(hole => {
      if (hole.position) {
        const pos = clampPos(+hole.position, L);
        // Calculate x position based on orientation
        // "From Left to Right" (Horizontal): holes start from left (-x)
        // "From Right to Left" (Vertical): holes start from right (+x)
        let xPos;
        if (hole.orientation === 'Vertical') {
          // From Right to Left - flip the position
          xPos = backWidth/2 - (pos / L) * backWidth;
        } else {
          // From Left to Right - normal position
          xPos = -backWidth/2 + (pos / L) * backWidth;
        }
        const diameter = +hole.diameter;
        const holeScale = dimensionalValues.holeScale;
        const radius = diameter * holeScale;
        
        if (hole.rail === '2') {
          // Side Slot 1 - on the middle slot
          const yPos = -26; // Centered in slot at y=-35
          const holeColor = hole.diameter === '8' ? '#2563eb' : '#16a34a'; // Blue for 8mm, Green for 10mm
          const holeElem = E('circle', {
            cx: xPos,
            cy: yPos,
            r: radius,
            class: 'hole-mark',
            style: `fill: ${holeColor} !important`,
            stroke: tooCloseHoles.has(hole.id) ? '#d73502' : '#000',
            'stroke-width': tooCloseHoles.has(hole.id) ? '3' : '1'
          });
          g.appendChild(holeElem);
          
          const labelOffset = labelOffsets.get(hole.id) || 0;
          
          // Smart label positioning - place labels below the rail with leader lines
          const labelY = -5 + (labelOffset * 20); // Changed from 15 to 20
          const labelX = xPos;
          
          // Create leader line from hole to label
          const leaderGroup = E('g', { class: 'hole-leader-group' });
          
          // Leader line path - curved for elegance
          const path = E('path', {
            d: `M ${xPos} ${yPos + radius} 
                L ${xPos} ${yPos + radius + 10} 
                L ${labelX} ${labelY - 10}`,
            stroke: '#999',
            'stroke-width': '0.75',
            fill: 'none',
            opacity: '0.8'
          });
          leaderGroup.appendChild(path);
          
          // Label background for readability
          const labelBg = E('rect', {
            x: labelX - 25,
            y: labelY - 10,
            width: 50,
            height: 20,
            fill: 'white',
            opacity: '0.9',
            rx: '2'
          });
          leaderGroup.appendChild(labelBg);
          
          // Label text
          const label = E('text', {
            x: labelX,
            y: labelY + 4,
            class: 'dimension-text hole-label',
            'text-anchor': 'middle',
            'font-size': '14px',
            'font-weight': '500',
            fill: tooCloseHoles.has(hole.id) ? '#d73502' : '#333'
          });
          label.textContent = `${pos}mm`;
          leaderGroup.appendChild(label);
          
          g.appendChild(leaderGroup);
        } else if (hole.rail === '3') {
          // Side Slot 2 - on the bottom slot
          // Check configuration for number of side slots
          const sideSlots = window.ALUMINUM_CONFIG && window.ALUMINUM_CONFIG.sideSlots || 2;
          if (sideSlots === 2) {
            const yPos = 24; // Position on bottom slot adjusted for y=15
            const holeColor = hole.diameter === '8' ? '#2563eb' : '#16a34a'; // Blue for 8mm, Green for 10mm
            const holeElem = E('circle', {
              cx: xPos,
              cy: yPos,
              r: radius,
              class: 'hole-mark',
              style: `fill: ${holeColor} !important`,
              stroke: tooCloseHoles.has(hole.id) ? '#d73502' : '#000',
              'stroke-width': tooCloseHoles.has(hole.id) ? '3' : '1'
            });
            g.appendChild(holeElem);
            
            // Smart label positioning for bottom slot
            const labelOffset = labelOffsets.get(hole.id) || 0;
            const labelY = 40 + (labelOffset * 20); // Changed from 15 to 20
            const labelX = xPos;
            
            // Create leader line from hole to label
            const leaderGroup = E('g', { class: 'hole-leader-group' });
            
            // Leader line path
            const path = E('path', {
              d: `M ${xPos} ${yPos + radius} 
                  L ${xPos} ${yPos + radius + 10} 
                  L ${labelX} ${labelY - 10}`,
              stroke: '#999',
              'stroke-width': '0.75',
              fill: 'none',
              opacity: '0.8'
            });
            leaderGroup.appendChild(path);
            
            // Label background for readability
            const labelBg = E('rect', {
              x: labelX - 20,
              y: labelY - 8,
              width: 40,
              height: 16,
              fill: 'white',
              opacity: '0.9',
              rx: '2'
            });
            leaderGroup.appendChild(labelBg);
            
            // Label text
            const label = E('text', {
              x: labelX,
              y: labelY + 4,
              class: 'dimension-text hole-label',
              'text-anchor': 'middle',
              'font-size': '14px',
              'font-weight': '500',
              fill: tooCloseHoles.has(hole.id) ? '#d73502' : '#333'
            });
            label.textContent = `${pos}mm`;
            leaderGroup.appendChild(label);
            
            g.appendChild(leaderGroup);
          }
        } else {
          // Top slot (rail === '1')
          // Calculate topXPos based on orientation
          let topXPos;
          if (hole.orientation === 'Vertical') {
            // From Right to Left - flip the position
            topXPos = backWidth/2 - (pos / L) * backWidth;
          } else {
            // From Left to Right - normal position
            topXPos = -backWidth/2 + (pos / L) * backWidth;
          }
          const yOffset = -80; // Adjusted for thinner top face
          const xOffset = topXPos + 24 * 0.5; // Adjusted for thinner depth
          const vRatio = dimensionalValues.vHoleRatio;
          const holeColor = hole.diameter === '8' ? '#2563eb' : '#16a34a'; // Blue for 8mm, Green for 10mm
          const holeElem = E('ellipse', {
            cx: xOffset,
            cy: yOffset,
            rx: radius,
            ry: radius * vRatio,
            class: 'hole-mark',
            style: `fill: ${holeColor} !important`,
            stroke: tooCloseHoles.has(hole.id) ? '#d73502' : '#000',
            'stroke-width': tooCloseHoles.has(hole.id) ? '3' : '1'
          });
          g.appendChild(holeElem);
          
          const labelOffset = labelOffsets.get(hole.id) || 0;
          
          // Smart label positioning - place labels above the top rail with leader lines
          const labelY = yOffset - radius * vRatio - 25 - (labelOffset * 20); // Changed from 15 to 20
          const labelX = xOffset;
          
          // Create leader line from hole to label
          const leaderGroup = E('g', { class: 'hole-leader-group' });
          
          // Leader line path
          const path = E('path', {
            d: `M ${xOffset} ${yOffset - radius * vRatio} 
                L ${xOffset} ${yOffset - radius * vRatio - 10} 
                L ${labelX} ${labelY + 10}`,
            stroke: '#999',
            'stroke-width': '0.75',
            fill: 'none',
            opacity: '0.8'
          });
          leaderGroup.appendChild(path);
          
          // Label background for readability
          const labelBg = E('rect', {
            x: labelX - 25,
            y: labelY - 10,
            width: 50,
            height: 20,
            fill: 'white',
            opacity: '0.9',
            rx: '2'
          });
          leaderGroup.appendChild(labelBg);
          
          // Label text
          const label = E('text', {
            x: labelX,
            y: labelY + 4,
            class: 'dimension-text hole-label',
            'text-anchor': 'middle',
            'font-size': '14px',
            'font-weight': '500',
            fill: tooCloseHoles.has(hole.id) ? '#d73502' : '#333'
          });
          label.textContent = `${pos}mm`;
          leaderGroup.appendChild(label);
          
          g.appendChild(leaderGroup);
        }
      }
    });
    
    drawDimensionLines(g, backWidth, backHeight, 60, backWidth, L, 0.5, 0.866025403784439);
    
    const leftTapped = document.querySelector('input[name="tappingSides"][value="Left"]').checked;
    const rightTapped = document.querySelector('input[name="tappingSides"][value="Right"]').checked;
    
    if (leftTapped) {
      // Left end face tapping - two circles aligned with side slots
      const leftEndX = -backWidth/2;
      const tapGroup = E('g', { class: 'tap-group' });
      
      // Top tapping circle - aligned with Side Slot 1 at y=-26
      const centerX1 = leftEndX + 12; // Adjusted for thinner depth
      const centerY1 = -26;
      
      const tapLeftTop = E('ellipse', {
        cx: centerX1,
        cy: centerY1,
        rx: leftTapping.radius * 0.4, // Compress more for thinner profile
        ry: leftTapping.radius, // Full height
        fill: 'none',
        class: 'tap-outline'
      });
      
      // Bottom tapping circle - aligned with Side Slot 2 at y=24
      const centerX2 = leftEndX + 12;
      const centerY2 = 24;
      
      const tapLeftBottom = E('ellipse', {
        cx: centerX2,
        cy: centerY2,
        rx: leftTapping.radius * 0.4,
        ry: leftTapping.radius,
        fill: 'none',
        class: 'tap-outline'
      });
      
      tapGroup.appendChild(tapLeftTop);
      tapGroup.appendChild(tapLeftBottom);
      g.appendChild(tapGroup);
    }
    
    if (rightTapped) {
      // Right end face tapping - two circles aligned with side slots
      const rightEndX = backWidth/2;
      const tapGroup = E('g', { class: 'tap-group' });
      
      // Top tapping circle - aligned with Side Slot 1
      const tapRightTop = E('ellipse', {
        cx: 161,
        cy: -26,
        rx: 4,
        ry: 12,
        fill: 'none',
        class: 'tap-outline'
      });
      
      // Bottom tapping circle - aligned with Side Slot 2
      const tapRightBottom = E('ellipse', {
        cx: 161,
        cy: 22,
        rx: 4,
        ry: 12,
        fill: 'none',
        class: 'tap-outline'
      });
      
      tapGroup.appendChild(tapRightTop);
      tapGroup.appendChild(tapRightBottom);
      g.appendChild(tapGroup);
    }
    
    // Add warning text if holes are too close
    if (tooCloseHoles.size > 0) {
      const warningGroup = E('g', { class: 'warning-group' });
      
      // Warning background
      const warningBg = E('rect', {
        x: -350,
        y: -180,
        width: 700,
        height: 55,
        rx: 10,
        fill: '#fefb1f',
        opacity: 0.5
      });
      warningGroup.appendChild(warningBg);
      
      // Warning icon
      const warningIcon = E('text', {
        x: -180,
        y: -155,
        class: 'warning-icon',
        fill: '#282828',
        'font-size': '20px',
        'font-weight': 'bold',
        'text-anchor': 'middle'
      });
      warningIcon.textContent = '⚠';
      warningGroup.appendChild(warningIcon);
      
      // Warning text - line 1
      const warningText1 = E('text', {
        x: 0,
        y: -155,
        class: 'warning-text',
        fill: '#282828',
        'font-size': '14px',
        'font-weight': 'bold',
        'text-anchor': 'middle'
      });
      warningText1.textContent = 'Holes too close!';
      warningGroup.appendChild(warningText1);
      
      // Warning text - line 2
      const warningText2 = E('text', {
        x: 0,
        y: -135,
        class: 'warning-text',
        fill: '#282828',
        'font-size': '12px',
        'text-anchor': 'middle'
      });
      warningText2.textContent = 'Maintain a minimum spacing of 15 mm between holes and a minimum distance of 10 mm from any edge.';
      warningGroup.appendChild(warningText2);
      
      g.appendChild(warningGroup);
    }
    
    parentG.appendChild(g);
  }
  
  function drawTSlotDetails(g, backWidth, backHeight, topDepth, topWidth, cosAngle, sinAngle) {
    // Check configuration for number of side slots
    const sideSlots = window.ALUMINUM_CONFIG && window.ALUMINUM_CONFIG.sideSlots || 2;
    
    // Side Slot 1 (middle slot) - adjusted for new dimensions
    const frontSlot = E('rect', {
      x: -150,
      y: -35,
      width: 300,
      height: 18,
      fill: '#aaa',
      stroke: '#666',
      'stroke-width': '2'
    });
    g.appendChild(frontSlot);
    
    // Side Slot 2 (bottom slot) - only show if configured for 2 slots
    if (sideSlots === 2) {
      const bottomSlot = E('rect', {
        x: -150,
        y: 15,
        width: 300,
        height: 18,
        fill: '#aaa',
        stroke: '#666',
        'stroke-width': '2'
      });
      g.appendChild(bottomSlot);
    }
    
    // Top slot - adjusted for thinner top face
    const topSlot = E('path', {
      d: `M -134.5 -85.8199925980631
          L -141.5 -74.54920074019369
          L 158.5 -74.54920074019369
          L 165.5 -85.8199925980631
          Z`,
      fill: '#aaa',
      stroke: '#666',
      'stroke-width': '2'
    });
    g.appendChild(topSlot);
  }
  
  function drawDimensionLines(g, backWidth, backHeight, topDepth, topWidth, realL, cosAngle, sinAngle) {
    const dimGroup = E('g', { class: 'dimensions' });
    
    // Line - adjusted for new rectangular shape
    const line = E('line', {
      x1: -150,
      y1: 80,
      x2: 150,
      y2: 80,
      class: 'dimension-line'
    });
    dimGroup.appendChild(line);
    
    // Left arrow - adjusted for new dimensions
    const leftArrow = E('path', {
      d: 'M -150 80 L -142 76 L -142 84 Z',
      class: 'dimension-arrow'
    });
    
    // Right arrow - adjusted for new dimensions
    const rightArrow = E('path', {
      d: 'M 150 80 L 142 76 L 142 84 Z',
      class: 'dimension-arrow'
    });
    dimGroup.appendChild(leftArrow);
    dimGroup.appendChild(rightArrow);
    
    // Length text - adjusted for new dimensions
    const lengthText = E('text', {
      x: 0,
      y: 110,
      class: 'dimension-text',
      'text-anchor': 'middle'
    });
    lengthText.textContent = `${realL} mm`;
    dimGroup.appendChild(lengthText);
    
    // Add "Side Slot View" label on the left
    const sideSlotLabel = E('text', {
      x: -190,
      y: 0,
      class: 'dimension-text',
      'text-anchor': 'middle',
      transform: 'rotate(-90, -190, 0)',
      fill: '#666',
      'font-size': '14px'
    });
    sideSlotLabel.textContent = 'Side Slot View';
    dimGroup.appendChild(sideSlotLabel);
    
    // Add "Top Slot View" label centered above the isometric view
    const topSlotLabel = E('text', {
      x: 0,
      y: -180,
      class: 'dimension-text',
      'text-anchor': 'middle',
      fill: '#666',
      'font-size': '14px'
    });
    topSlotLabel.textContent = 'Top Slot View';
    dimGroup.appendChild(topSlotLabel);
    
    g.appendChild(dimGroup);
  }
  
  // Function to handle length reduction with hole removal warning
  function handleLengthReduction(newLength) {
    // Find holes that would be outside the new length
    const affectedHoles = holes.filter(h => h.position && parseFloat(h.position) > newLength);
    
    if (affectedHoles.length > 0) {
      // Create a list of affected hole positions
      const positions = affectedHoles.map(h => `${h.position}mm`).join(', ');
      
      // Show confirmation dialog
      const message = `Reducing length to ${newLength}mm will remove ${affectedHoles.length} hole${affectedHoles.length > 1 ? 's' : ''} at position${affectedHoles.length > 1 ? 's' : ''}: ${positions}\n\nDo you want to continue?`;
      
      if (confirm(message)) {
        // Remove the affected holes
        affectedHoles.forEach(hole => {
          // Remove from DOM
          const holeElements = document.querySelectorAll('.hole-item');
          holeElements.forEach(elem => {
            const posInput = elem.querySelector('.hole-pos');
            if (posInput && posInput.value === String(hole.position)) {
              elem.remove();
            }
          });
          
          // Remove from holes array
          const index = holes.findIndex(h => h.id === hole.id);
          if (index > -1) {
            holes.splice(index, 1);
          }
        });
        
        // Update holes data and redraw
        updateHolesData();
        updatePrice();
        draw();
        return true; // Allow length change
      } else {
        return false; // Cancel length change
      }
    }
    return true; // No affected holes, allow change
  }
  
  // Length controls
  if (lengthSlider && lengthInput) {
    // Function to update bubble position
    function updateSliderBubble() {
      const bubble = document.getElementById('slider-bubble');
      if (bubble) {
        const value = parseFloat(lengthSlider.value);
        const min = parseFloat(lengthSlider.min);
        const max = parseFloat(lengthSlider.max);
        const percentage = ((value - min) / (max - min)) * 100;
        
        bubble.style.left = percentage + '%';
        bubble.textContent = value + 'mm';
      }
    }
    
    // Function to update adjustment button states
    function updateAdjustmentButtons() {
      const value = parseInt(lengthInput.value) || 1000;
      const decreaseBtn = document.getElementById('length-decrease');
      const increaseBtn = document.getElementById('length-increase');
      
      if (decreaseBtn) decreaseBtn.disabled = value <= 30;
      if (increaseBtn) increaseBtn.disabled = value >= 3000;
    }
    lengthSlider.addEventListener('input', () => {
      const v = clampLen(+lengthSlider.value);
      
      // Check if we're reducing length and have holes that would be affected
      const currentLength = parseFloat(lengthInput.value) || 1000;
      if (v < currentLength) {
        if (!handleLengthReduction(v)) {
          // User cancelled, revert slider
          lengthSlider.value = currentLength;
          return;
        }
      }
      
      lengthInput.value = v;
      lengthSlider.value = v;
      updateHoleInputsMax();
      updatePrice();
      draw();
      
      // Show notification if slider reaches 3000
      if (v >= 3000) {
        const notification = document.getElementById('length-notification');
        if (notification) {
          notification.classList.remove('hiding');
          notification.style.display = 'block';
        }
      }
    });
    
    // Improved input handling to fix typing issues
    lengthInput.addEventListener('input', (e) => {
      // Allow typing without immediate clamping
      const rawValue = e.target.value;
      
      // Only update if it's a valid number
      if (rawValue && !isNaN(rawValue)) {
        const numValue = parseInt(rawValue);
        
        // Only clamp and update if within reasonable bounds
        if (numValue >= 30 && numValue <= 3000) {
          // Check if we're reducing length and have holes that would be affected
          const currentLength = parseFloat(lengthSlider.value) || 1000;
          if (numValue < currentLength) {
            if (!handleLengthReduction(numValue)) {
              // User cancelled, revert input
              lengthInput.value = currentLength;
              return;
            }
          }
          
          lengthSlider.value = numValue;
          updateHoleInputsMax();
          updatePrice();
          draw();
          updateConfigId();
        }
      }
    });
    
    // Handle when user leaves the field - enforce limits
    lengthInput.addEventListener('blur', () => {
      const currentValue = +lengthInput.value || 1000;
      const previousLength = parseFloat(lengthSlider.value) || 1000;
      
      // Check for hole conflicts when reducing length
      if (currentValue < previousLength) {
        if (!handleLengthReduction(currentValue)) {
          // User cancelled, revert to previous length
          lengthInput.value = previousLength;
          lengthSlider.value = previousLength;
          return;
        }
      }
      
      // Show notification if user tried to enter 3000 or over
      if (currentValue >= 3000) {
        const notification = document.getElementById('length-notification');
        if (notification) {
          // Remove hiding class and show
          notification.classList.remove('hiding');
          notification.style.display = 'block';
          
          // No auto-hide - user must close manually or it stays visible
        }
      }
      
      const v = clampLen(currentValue);
      lengthInput.value = v;
      lengthSlider.value = v;
      updateHoleInputsMax();
      updatePrice();
      draw();
      updateConfigId();
    });
    
    // Allow better keyboard navigation
    lengthInput.addEventListener('keydown', (e) => {
      const currentValue = parseInt(lengthInput.value) || 1000;
      
      // Arrow up/down for fine control (hold Shift for +/-10)
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        const newValue = Math.min(3000, currentValue + (e.shiftKey ? 10 : 1));
        lengthInput.value = newValue;
        lengthSlider.value = newValue;
        updateHoleInputsMax();
        updatePrice();
        draw();
        updateConfigId();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        const newValue = Math.max(30, currentValue - (e.shiftKey ? 10 : 1));
        lengthInput.value = newValue;
        lengthSlider.value = newValue;
        updateHoleInputsMax();
        updatePrice();
        draw();
        updateConfigId();
      }
    });
  }
  
  function updateHoleInputsMax() {
    const L = clampLen(+lengthInput.value);
    holesContainer.querySelectorAll('.hole-pos').forEach(input => {
      input.max = L;
      // If current value exceeds new max, adjust it
      if (+input.value > L) {
        input.value = L;
        // Trigger input event to update the hole data
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }
  
  // Add hole functionality
  if (addHoleBtn) {
    console.log('Setting up add hole button (two-complex)');
    // Use a small delay to ensure button is fully rendered
    setTimeout(() => {
      addHoleBtn.addEventListener('click', () => {
        console.log('Add hole button clicked (two-complex)');
        const L = clampLen(+lengthInput.value);
      const holeId = ++holeIdCounter;
      const holeItem = document.createElement('div');
      holeItem.className = 'hole-item';
      
      // Check configuration for number of side slots
      const sideSlots = window.ALUMINUM_CONFIG && window.ALUMINUM_CONFIG.sideSlots || 2;
      
      let railOptions = `
            <option value="1">Top slot</option>
            <option value="2">Side slot${sideSlots === 2 ? ' 1' : ''}</option>
      `;
      
      if (sideSlots === 2) {
        railOptions += `            <option value="3">Side slot 2</option>`;
      }
      
      holeItem.innerHTML = `
        <button type="button" class="remove-btn">
          <span>×</span>
        </button>
        <div class="hole-controls">
          <input type="number" class="hole-input hole-pos" placeholder="Position inside slot (mm)" min="0" max="${L}" step="1" required>
          <select class="select-input hole-orient">
            <option value="Horizontal">From Left to Right</option>
            <option value="Vertical">From Right to Left</option>
          </select>
          <select class="select-input hole-rail">
${railOptions}
          </select>
          <select class="select-input hole-diameter">
            <option value="8" style="color: #2563eb;">8mm Hole</option>
            ${(hole10mmTopPrice > 0 || hole10mmSidePrice > 0) ? '<option value="10" style="color: #16a34a;">10mm Hole</option>' : ''}
          </select>
        </div>
      `;
      
      holesContainer.appendChild(holeItem);
      
      const hole = {
        id: holeId,
        position: '',
        orientation: 'Horizontal',
        rail: '1',
        diameter: '8'
      };
      holes.push(hole);
      
      const posInput = holeItem.querySelector('.hole-pos');
      const orientSelect = holeItem.querySelector('.hole-orient');
      const railSelect = holeItem.querySelector('.hole-rail');
      const diameterSelect = holeItem.querySelector('.hole-diameter');
      const removeBtn = holeItem.querySelector('.remove-btn');
      
      posInput.addEventListener('input', () => {
        const L = clampLen(+lengthInput.value);
        let pos = +posInput.value;
        
        // Validate position doesn't exceed beam length
        if (pos > L) {
          pos = L;
          posInput.value = L;
          // Show a brief warning
          posInput.style.borderColor = '#d73502';
          setTimeout(() => {
            posInput.style.borderColor = '';
          }, 2000);
        }
        
        hole.position = posInput.value;
        updateHolesData();
        updatePrice();
        draw();
      });
      
      orientSelect.addEventListener('change', () => {
        hole.orientation = orientSelect.value;
        updateHolesData();
        draw(); // Redraw to update hole positions
      });
      
      railSelect.addEventListener('change', () => {
        hole.rail = railSelect.value;
        
        // Update diameter options based on rail selection
        const isTopSlot = railSelect.value === '1';
        const show10mm = isTopSlot ? 
          (hole10mmTopPrice > 0) : 
          (hole10mmSidePrice > 0);
        
        // Update diameter dropdown options
        const currentDiameter = diameterSelect.value;
        diameterSelect.innerHTML = `
          <option value="8" style="color: #2563eb;">8mm Hole</option>
          ${show10mm ? '<option value="10" style="color: #16a34a;">10mm Hole</option>' : ''}
        `;
        
        // Restore previous selection if still available
        if (currentDiameter === '10' && show10mm) {
          diameterSelect.value = '10';
        } else {
          diameterSelect.value = '8';
          hole.diameter = '8';
        }
        
        updateHolesData();
        updatePrice();
        draw();
      });
      
      diameterSelect.addEventListener('change', () => {
        hole.diameter = diameterSelect.value;
        updateHolesData();
        updatePrice();
        draw();
      });
      
      removeBtn.addEventListener('click', () => {
        holes = holes.filter(h => h.id !== holeId);
        holeItem.remove();
        updateHolesData();
        updatePrice();
        draw();
      });
      
      updateHolesData();
      updatePrice();
      draw();
    });
    }, 50); // Close the setTimeout
  }
  
    // Tapping checkboxes
    tapChecks.forEach(cb => {
      const wrapper = cb.closest('.checkbox-wrapper');
      cb.addEventListener('change', () => {
        if (cb.checked) {
          wrapper.classList.add('checked');
        } else {
          wrapper.classList.remove('checked');
        }
        syncTaps();
      });
    });
    
    // Initial draw and price update when calculator loads
    setTimeout(() => {
      updatePrice();
      draw();
      updateZoom();
    }, 100);
    
    // Listen for successful cart additions to mark for reset
    document.addEventListener('cart:added', () => {
      console.log('Item added to cart, marking for reset');
      sessionStorage.setItem('calculatorNeedsReset', 'true');
    });
    
    // Reset calculator after cart operations if marked
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && sessionStorage.getItem('calculatorNeedsReset') === 'true') {
        console.log('Resetting calculator after cart operation - DISABLED');
        sessionStorage.removeItem('calculatorNeedsReset');
        // COMMENTED OUT - Don't reset
        // resetCalculator();
        updatePrice();
        draw();
      }
    });
    
    // Also listen for cart drawer close events (some themes emit this)
    document.addEventListener('cart:close', () => {
      if (sessionStorage.getItem('calculatorNeedsReset') === 'true') {
        console.log('Cart drawer closed, resetting calculator - DISABLED');
        sessionStorage.removeItem('calculatorNeedsReset');
        // COMMENTED OUT - Don't reset
        // resetCalculator();
        updatePrice();
        draw();
      }
    });
    
  } // End of initializeCalculator function

})(); // End of main IIFE
